@if (selected(); as selected) {
  <div class="mb-4 flex flex-wrap gap-1">
    <div>Wybrany punkt:</div>
    <div class="font-bold">
      {{ selected?.description }}
    </div>
  </div>
}

<p-button
  (click)="handleChoosePointClickEvent()"
  [label]="choosePointButtonLabel()"
  severity="secondary" />

<p-dialog
  [customCloseEvent]="customCloseEvent"
  [style]="{ height: '90vh', width: '90vw' }"
  [visible]="dialogVisibility()"
  appPrimengDialog
  appPrimengDialogCustomCloseEvent
  header="Wybierz paczkomat">
  @if (dialogVisibility()) {
    <app-in-post-point-select-widget
      (pointSelectEvent)="handlePointSelectEvent($event)"
      [location]="location()"
      [international]="international()"
      [country]="country()"
      [sandbox]="isSandbox()"
      [token]="siteKey()" />
  }
</p-dialog>
